var map = {
	"./icon-account.svg": "e666",
	"./icon-cog.svg": "ff92",
	"./icon-remote.svg": "bd91",
	"./icon-sites.svg": "0cc0",
	"./icon-statistic.svg": "930a",
	"./icon-themes.svg": "3f5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d423";